import { render } from "./DocumentPostePage.vue?vue&type=template&id=2e2c369e"
import script from "./DocumentPostePage.vue?vue&type=script&lang=js"
export * from "./DocumentPostePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__